import React, { useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import MainLayout from 'src/layouts/main-layout/main-layout';
import MainPage from 'src/pages/main-page/main-page';
import PopupCookies from 'src/components/popups/popup-cookies';

import useAmoSocialButton from 'src/hooks/use-amo-social-button';
import useGaTracker from 'src/hooks/use-ga-tracker';
import useSmartlookAnalytics from 'src/hooks/use-smartlook-analytics';
import useVhValue from 'src/hooks/use-vh-value';
import { AppRoute, IS_HIDE_COOKIES_POPUP } from 'src/constants';
import { checkDisabledCookies } from 'src/utils';

import 'src/scss/index.scss';

const App = () => {
  const cookiesDisabled = checkDisabledCookies();
  const [enableCookies, setEnableCookies] = useState<boolean>(
    IS_HIDE_COOKIES_POPUP || !cookiesDisabled
  );
  useVhValue();
  useGaTracker(enableCookies);
  useSmartlookAnalytics();
  useAmoSocialButton();

  return (
    <div className="app">
      <Routes>
        <Route path={AppRoute.ROOT} element={<MainLayout children={<MainPage />} />} />
        <Route path="*" element={<Navigate replace to={AppRoute.ROOT} />} />
      </Routes>
      {!IS_HIDE_COOKIES_POPUP && <PopupCookies setEnableCookies={setEnableCookies} />}
    </div>
  );
};

export default App;
